const contractAddress = "0xad51293Be3e72b6f88a8Ec525119830B4B135E8b";

export default contractAddress;